import { DefaultTheme } from 'styled-components';

import { colors } from '../colors';
import { Theme } from '../types';

const theme3: DefaultTheme = {
  name: Theme.theme3,

  // Text
  fontFamily: `sofia-pro, san-serif`,
  fontColor: colors.deepTeal,
  fontColorSecondary: colors.rock,
  fontWeight: 400,
  fontSize: '16px',
  fontLineHeight: '24px',
  lineHeight: 'normal',
  errorColor: colors.danger500,
  iconColor: colors.rock,
  disabledColor: colors.beachWind,
  borderRadius: '6px',
  spacing: {
    xsmall: '8px',
    small: '16px',
    medium: '24px',
  },

  // Accordion
  accordionBorderColor: colors.neutral400,
  accordionPanelBackgorundColor: colors.neutral100,
  accordionDropDownIcon: {
    type: 'down',
    viewSize: 24,
  },

  // BookingCalendar
  bookingCalendarSlotBorderColor: colors.neutral400,
  bookingCalendarSlotBorderColorActive: colors.deepTeal,
  bookingCalendarSlotBackgroundColor: colors.white,
  bookingCalendarSlotBackgroundColorHover: colors.primaryOpacity,
  bookingCalendarSlotBackgroundColorActive: colors.primaryOpacity,
  bookingCalendarIconColor: colors.deepTeal,
  bookingCalendarSlotsFontWeight: 400,

  // Button
  buttonBaselineAdjustment: {
    xsmall: '-2px',
    small: '-2px',
    smallmedium: '-3px',
    medium: '-3px',
    large: '-3px',
  },
  buttonFont: `sofia-pro, san-serif`,
  buttonFontSize: {
    xsmall: '14px',
    small: '14px',
    smallmedium: '14px',
    medium: '16px',
    large: '16px',
  },
  buttonFontWeight: 700,
  buttonFocusShadow: `none`,
  buttonPrimaryTextColor: colors.white,
  buttonPrimaryHoverTextColor: colors.white,
  buttonPrimaryDisabledTextColor: colors.rock,
  buttonPrimaryColor: colors.deepTeal,
  buttonPrimaryHoverColor: colors.deepTeal,
  buttonPrimaryDisabledColor: colors.neutral500,
  buttonSecondaryBorderColor: colors.deepTeal,
  buttonSecondaryColor: colors.deepTeal,
  buttonSecondaryBackgroundColor: 'transparent',
  buttonSecondaryHoverColor: colors.deepTeal,
  buttonSecondaryHoverBorderColor: colors.deepTeal,
  buttonSecondaryDisabledColor: `${colors.deepTeal}80`,
  buttonBorderRadius: {
    xsmall: '4px',
    small: '4px',
    medium: '6px',
    large: '6px',
  },
  buttonHeight: {
    xsmall: '32px',
    small: '36px',
    smallmedium: '40px',
    medium: '48px',
    large: '54px',
  },

  // Card
  cardBorderColor: colors.neutral400,
  cardPanelBackgorundColor: colors.neutral100,

  // Checkbox
  checkboxColor: colors.deepTeal,
  checkboxFontWeight: 400,
  checkboxBorderColor: colors.neutral600,
  checkboxBorderActiveColor: colors.deepTeal,
  checkboxBackgroundColor: colors.white,
  checkboxBackgroundActiveColor: colors.deepTeal,
  checkboxShadow: 'transparent',
  checkboxHover: colors.deepTeal,
  checkboxLabelIdentation: '32px',

  // Chip
  chipColor: colors.white,
  chipBackgroundColor: colors.deepTeal,

  // DatePicker
  datePickerShowOnlyBottomBorder: true,
  datePickerColor: colors.deepTeal,
  datePickerBorderColor: colors.neutral600,
  datePickerSecondaryBorderColor: colors.deepTeal,
  datePickerPlaceholderColor: colors.rock,
  datePickerFocusedBorderColor: colors.deepTeal,
  datePickerIconDisabledColor: colors.beachWind,
  datePickerActiveColor: colors.deepTeal,
  datePickerActiveBorderColor: colors.deepTeal,
  datePickerActiveBackgroundColor: colors.beachWind,
  datePickerHoverBackgroundColor: colors.beachWind,
  datePickerHoverBorderColor: colors.beachWind,
  datePickerHoverColor: colors.deepTeal,
  datePickerHoverShadow: 'none',
  datePickerIconColor: colors.rock,
  datePickerIconColorHover: colors.rock,
  datePickerPadding: '7px 12px 5px',
  datePickerCalendarIconPadding: '5px 12px',
  datePickerBackgroundColor: colors.white,
  datePickerInputHeight: '44px',
  datePickerTop: '8px',

  // DateRangePicker
  dateRangePickerIconColor: colors.rock,
  dateRangePickerDisabledIconColor: colors.beachWind,
  dateRangePickerSpanActiveColor: colors.deepTeal,
  dateRangePickerSpanActiveBorderColor: colors.deepTeal,
  dateRangePickerSpanActiveBackgroundColor: colors.beachWind,
  dateRangePickerSpanHoverColor: colors.deepTeal,
  dateRangePickerSpanHoverBorderColor: colors.deepTeal,
  dateRangePickerSpanHoverBackgroundColor: colors.beachWind,

  // Dropdown
  dropdownIconColor: colors.rock,
  dropdownListItemBackgroundColor: colors.neutral100,
  dropdownListItemPadding: '8px 16px',
  dropdownIcon: {
    type: 'down',
    viewSize: 24,
  },

  // Footer
  footerTextColor: colors.robinsEggBlue,
  footerHeadingColor: colors.edgewater,
  footerCheckIconColor: colors.mossGreen,
  footerSocialIconColor: colors.robinsEggBlue,
  footerLineColor: colors.robinsEggBlue,
  footerInputErrorColor: colors.danger800,
  footerIconColor: colors.deepTeal,
  footerBackgroundDark: colors.deepTeal,
  footerBackgroundLight: '#244547',

  // Form
  formRowLabelColor: colors.deepTeal,
  formRowLabelFontSize: '18px',
  formRowLabelFontWeight: '800',
  formRowLabelPadding: '0 0 24px 0',
  formRowGap: '24px',

  // Heading
  // sizes: 1, 2, 3, 4, 5, 6, 7
  headingSizes: ['48px', '36px', '32px', '24px', '18px', '16px', '14px'],
  headingLineHeight: ['138%', '138%', '138%', '138%', '138%', '175%', '157%'],
  headingMobileSizes: ['36px', '32px', '24px', '18px', '18px', '16px', '14px'],
  headingOutline: '14px',
  headingOutlineLineHeight: '21px',
  headingFontFamily: `sofia-pro, san-serif`,
  headingFontWeight: '400',
  headingFontWeightBold: '800',

  // Link
  linkColor: colors.deepTeal,
  linkHoverColor: colors.deepTeal,
  linkDisabledColor: colors.beachWind,

  // LinkButton
  linkButtonIconColor: colors.rock,
  linkButtonIconColorDisabled: colors.beachWind,
  linkButtonIconSize: {
    xsmall: 18,
    small: 18,
    smallmedium: 20,
    medium: 20,
    large: 24,
  },
  linkButtonFontWeight: '700',

  // Modal
  modalLineColor: colors.neutral400,
  modalIconColor: colors.deepTeal,

  // Nav
  navLinkColor: colors.deepTeal,
  navLinkBackgroundColor: colors.deepTeal,
  navSubMenuItemHoverBackgroundColor: colors.success100,
  navMenuItemBackgroundColor: colors.success100,
  navMobileSignInLinkColor: colors.deepTeal,
  navUserIconBackgroundColor: colors.geyser,
  navUserIconColor: colors.deepTeal,
  navMenuHamburgerColor: colors.deepTeal,
  navBorderColor: colors.neutral400,

  // Navbar
  navbarColor: colors.deepTeal,
  navbarColorHover: colors.deepTeal,

  // Notification
  notificationBorderColor: colors.neutral400,
  notificationBorderRadius: '4px',
  notificationColor: {
    info: colors.info800,
    error: colors.danger800,
    warning: colors.warning800,
    success: colors.success800,
    neutral: colors.deepTeal,
  },
  notificationBackgroundColor: {
    info: colors.info100,
    error: colors.danger100,
    warning: colors.warning100,
    success: colors.success100,
    neutral: colors.neutral200,
  },
  notificationSpacing: '8px',

  // PDF
  pdfPanelBackgroundColor: colors.white,
  pdfBorderColor: colors.neutral400,
  pdfControlsColor: colors.neutral200,
  pdfControlsDisabledColor: colors.neutral100,
  pdfIconColor: colors.rock,
  pdfIconDisabledColor: colors.beachWind,
  pdfControlsIconColor: colors.rock,

  // Radio
  radioColor: colors.deepTeal,
  radioBorderColor: colors.rock,
  radioBorderActiveColor: colors.deepTeal,
  radioBackgroundColor: colors.white,
  radioBackgroundActiveColor: colors.deepTeal,
  radioShadow: 'transparent',
  radioHover: colors.deepTeal,
  radioSize: 16,
  radioInputTopPosition: 2,

  // Section
  sectionBorderColor: colors.neutral700,
  sectionIconColor: colors.neutral700,

  // Select Input
  selectShowOnlyBottomBorder: true,
  selectShowIndicatorAnimation: true,
  selectColor: colors.deepTeal,
  selectPlaceholderColor: colors.rock,
  selectDisabledColor: colors.beachWind,
  selectDisabledBorderColor: colors.beachWind,
  selectBorderColor: colors.deepTeal,
  selectPrimaryBorderColor: colors.neutral600,
  selectPrimaryHoverBorderColor: colors.neutral600,
  selectPrimaryFocusedBorderColor: colors.deepTeal,
  selectPrimaryDisabledBackgroundColor: colors.white,
  selectPrimaryIndicatorPadding: '0',
  selectPrimaryBorderRadius: '6px',
  selectPrimaryBackgroundColor: colors.white,
  selectTertiaryBorderColor: colors.deepTeal,
  selectTertiaryHoverBorderColor: colors.deepTeal,
  selectTertiaryFocusedBorderColor: colors.deepTeal,
  selectTertiaryDisabledBackgroundColor: 'transparent',
  selectTertiaryIndicatorPadding: '0',
  selectTertiaryBorderRadius: '3px',
  selectTertiaryBackgroundColor: 'transparent',
  selectHoverShadow: 'none',
  selectInputPadding: '0 12px 0 4px',
  selectMenuShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  selectMenuBorder: `0`,
  selectOptionPadding: '8px 16px',
  selectOptionActiveColor: colors.deepTeal,
  selectOptionMultiLineHeight: '20px',
  selectOptionMultiMargin: '-2px',
  selectIndicatorIcon: 'down',
  selectIndicatorSearchIcon: 'explore',
  selectIndicatorIconSize: 24,
  selectIndicatorIconViewSize: 24,
  selectIndicatorSeachIconSize: 24,
  selectIndicatorSeachIconViewSize: 24,
  selectIndicatorIconColor: colors.rock,
  selectInputHeight: '46px',

  // Table
  tableIconColor: colors.rock,
  tableBorderColor: colors.neutral400,
  tableIconColorDisabled: colors.beachWind,
  tableHeaderTextColor: colors.deepTeal,
  tableCellTextColor: colors.deepTeal,
  tableCellSelectedTextColor: colors.deepTeal,
  tableRowBackgroundColorHover: colors.primaryOpacity,
  tableRowBackgroundColorSelected: colors.primaryOpacity,
  tableRowPrimaryBackgroundColor: colors.white,
  tableRowSecondaryBackgroundColor: colors.alicebluegrey,
  tableRowExpandedPrimaryBackgroundColor: `${colors.primaryOpacity}80`,
  tableRowExpandedSecondaryBackgroundColor: `${colors.primaryOpacity}40`,
  tablePaginationIconColorDisabled: colors.beachWind,
  tablePaginationIconColor: colors.rock,
  tablePaginationTextColor: colors.rock,
  tablePaginationTextColorActive: colors.deepTeal,
  tablePaginationBackgroundColorActive: colors.neutral300,

  // Tabs
  tabsActiveBorderColor: colors.deepTeal,
  tabsActiveColor: colors.deepTeal,
  tabsActiveFontWeight: 400,
  tabsBackgroundColor: colors.neutral200,
  tabsBackgroundColorHover: colors.neutral200,
  tabsBorderColor: colors.neutral400,
  tabsBorderBottom: '0',
  tabsBorderTop: '0',
  tabsDisabledBackgroundColor: colors.neutral200,
  tabsDisabledColor: colors.neutral600,
  tabsFontSize: '14px',
  tabsHeight: '48px',
  tabsLetterSpacing: '1px',

  // Text Input
  textInputShowOnlyBottomBorder: true,
  textInputColor: colors.deepTeal,
  textInputFocusedColor: colors.deepTeal,
  textInputBorderColor: colors.neutral600,
  textInputSecondaryBorderColor: colors.deepTeal,
  textInputFocusedBorderColor: colors.deepTeal,
  textInputBackgroundColor: colors.white,
  textInputHoverShadow: 'none',
  textInputPadding: '0 12px 3px',
  textInputPlaceholderColor: colors.rock,
  textInputLabelColor: colors.rock,
  textInputNotePadding: '0 16px',
  textInputNoteFontStyle: 'italic',
  textInputDisabledColor: colors.beachWind,
  textInputDisabledBackgroundColor: colors.white,
  textInputDisabledBorderColor: colors.beachWind,
  textInputShowAnimatedLabel: false,
  textInputIconColor: colors.rock,
  textInputHeight: '46px',
  textInputIconRight: '12px',

  // Textarea Input
  textAreaInputTextColor: colors.deepTeal,
  textAreaInputBorderColor: colors.neutral600,
  textAreaInputSecondaryBorderColor: colors.deepTeal,
  textAreaInputFocusTextColor: colors.deepTeal,
  textAreaInputFocusBorderColor: colors.deepTeal,
  textAreaInputDisabledTextColor: colors.beachWind,
  textAreaInputDisabledBorderColor: colors.beachWind,
  textAreaInputPlaceholderColor: colors.darkSilver,

  // Toggle
  toggleColor: colors.neutral500,
  toggleActiveColor: colors.deepTeal,

  // ToggleButtonGroup
  toggleButtonGroupHeight: {
    xsmall: '24px',
    small: '28px',
    medium: '40px',
    large: '46px',
  },

  // UserDropdown
  userDropdownColor: colors.deepTeal,
  userDropdownColorHover: colors.deepTeal,

  inputErrorMessagePadding: '0 16px',
};

export default theme3;
